import { ContractType } from 'app/constants/contractType'

export const getContractType = (type) => {
  let contractType = ContractType.NotSet

  switch (type) {
    case 1:
      contractType = ContractType.Equivalent
      break
    case 2:
      contractType = ContractType.Basic
      break
    case 3:
      contractType = ContractType.Task
      break
    case 4:
      contractType = ContractType.Mix
      break
    case 5:
      contractType = ContractType.Intermittent
      break
    case 6:
      contractType = ContractType.CivilLawAgreement
      break
    case 7:
      contractType = ContractType.SelfEmployment
      break
  }

  return contractType
}
